import React, { useState } from 'react';
import styled from 'styled-components';
import AIChat from '../AIChat';
import AIImageGen from '../AIImageGen';

function AIChatApp() {
  const [activeTab, setActiveTab] = useState('chat');

  return (
    <AIChatSection>
      <TabContainer>
        <Tab active={activeTab === 'chat'} onClick={() => setActiveTab('chat')}>
          AI Chat
        </Tab>
        <Tab active={activeTab === 'image'} onClick={() => setActiveTab('image')}>
          AI Image Generation
        </Tab>
      </TabContainer>
      
      <TabContent>
        {activeTab === 'chat' && <AIChat />}
        {activeTab === 'image' && <AIImageGen />}
      </TabContent>
    </AIChatSection>
  );
}

const AIChatSection = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const TabContainer = styled.div`
  display: flex;
  gap: 0;
  background-color: var(--bg-secondary);
  border-bottom: 2px solid var(--card-border);
`;

const Tab = styled.button`
  padding: 1rem 2rem;
  background-color: ${props => props.active ? 'var(--card-bg)' : 'transparent'};
  color: ${props => props.active ? 'var(--accent-color)' : 'var(--text-secondary)'};
  border: none;
  border-bottom: 3px solid ${props => props.active ? 'var(--accent-color)' : 'transparent'};
  cursor: pointer;
  font-weight: ${props => props.active ? '600' : '500'};
  font-size: 1rem;
  transition: all 0.2s;
  position: relative;
  top: 2px;

  &:hover {
    background-color: ${props => props.active ? 'var(--card-bg)' : 'rgba(0, 0, 0, 0.05)'};
    color: ${props => props.active ? 'var(--accent-color)' : 'var(--text-primary)'};
  }
`;

const TabContent = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export default AIChatApp;
